export default "__VITE_ASSET__DL8rJ9j___"